import { removeParentNodeOfType } from 'prosemirror-utils';
import { findChildTableRows, findParentTableBody, findParentTableRow } from '../utils';
export const removeCurrentRow = (state, dispatch) => {
    const parentRow = findParentTableRow(state.selection);
    const parentBody = findParentTableBody(state.selection);
    if (!parentRow || !parentBody) {
        return false;
    }
    if (findChildTableRows(parentBody.node).length < 2) {
        // there is one row left
        return false;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(removeParentNodeOfType(parentRow.node.type)(state.tr));
    return true;
};
